module.exports = __webpack_public_path__ + "close-16.77c3dfdc.svg";